import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';

export const SponsorshipsSkeleton = () => {
  return (
    <div className="component flex flex-col gap-comfy-xl max-w-md">
      <div className="max-w-xs">
        <Skeleton height={80} />
      </div>
      <Skeleton height={400} />
    </div>
  );
};
